import type { ConfigFlavor } from '@/api/opennebula';

/**
 * Load balancers offer a single fixed ladder of balanced standard sizes
 * (memory = 2× vCPU), stepping v2g-standard-1-2 → 2-4 → 4-8 → 8-16 → 16-32 → 32-64.
 * No processor/memory-optimized split — overkill for an LB. A tier whose flavor
 * isn't in the catalog is skipped, so the ladder only offers what exists.
 */
const LB_CORE_TIERS = [1, 2, 4, 8, 16, 32];

/** Default size for a new LB — sensible baseline, not the 1-vCPU floor. */
export const LB_DEFAULT_FLAVOR = 'v2g-standard-2-4';

export function lbFlavors(flavors: ConfigFlavor[]): ConfigFlavor[] {
  return LB_CORE_TIERS.map((cores) =>
    flavors.find(
      (f) => (f.type ?? 'standard') === 'standard' && f.cores === cores && f.memory === cores * 2,
    ),
  ).filter((f): f is ConfigFlavor => !!f);
}
